export const GET_PROJECT_TEMPLATE = "GET_PROJECT_TEMPLATE"
export const GET_PROJECT_TEMPLATE_SUCCESS = "GET_PROJECT_TEMPLATE_SUCCESS"
export const GET_PROJECT_TEMPLATE_FAIL = "GET_PROJECT_TEMPLATE_FAIL"

export const GET_PROJECT_TEMPLATE_DETAIL = "GET_PROJECT_TEMPLATE_DETAIL"
export const GET_PROJECT_TEMPLATE_DETAIL_SUCCESS = "GET_PROJECT_TEMPLATE_DETAIL_SUCCESS"
export const GET_PROJECT_TEMPLATE_DETAIL_ERROR = "GET_PROJECT_TEMPLATE_DETAIL_ERROR"
